export default __webpack_public_path__ + "assets/models/c8585a15b8437d90fd533c4301e349b7.glb";